import AiSupervision from './Index.vue';

export const routes = [
  {
    path: 'supervisao-ia',
    name: 'talkvia_ai_supervision',
    meta: {
      permissions: ['administrator'],
      superAdminOrAdmin: true,
    },
    component: AiSupervision,
  },
];
